import { useCallback } from 'react';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LfJOnIsAAAAABVLd1Vian6jaNw4DYQSQbFvtSKI';

/**
 * Returns a function to execute reCAPTCHA v3 and get a token.
 * Skips when grecaptcha is not loaded (e.g. local dev without script).
 */
export function useRecaptcha() {
  const executeRecaptcha = useCallback(async (action) => {
    if (typeof window === 'undefined' || !window.grecaptcha || !window.grecaptcha.execute) {
      return null;
    }
    try {
      const timeoutMs = 10000;
      const token = await Promise.race([
        window.grecaptcha.execute(SITE_KEY, { action }),
        new Promise((_, reject) => setTimeout(() => reject(new Error('reCAPTCHA timeout')), timeoutMs))
      ]);
      return token;
    } catch (err) {
      console.error('reCAPTCHA execute error:', err);
      return null;
    }
  }, []);

  return { executeRecaptcha };
}
